module.exports = __webpack_public_path__ + "static/media/found-logo.cb2a4e43.png";